import  { useState, Suspense } from "react";
import React from 'react';
import ItemIndicator from './ItemIndicatorInfo';
import "./IndicatorInfo.css";

const SimpleGraph = React.lazy(() => import("./SimpleGraph"));

const IndicatorInfo = ({ data }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleItemClick = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const [isMobile, setIsMobile] = useState(() => {
    // Inicializa o estado com base na verificação de mídia
    if (typeof window !== "undefined") {
      return window.matchMedia("(max-width: 768px)").matches;
    }
    return false;
  });

  

  return isMobile ? (
    <div
      className={`container-detailedIndex ${
        expandedIndex !== null ? "has-expanded" : ""
      }`}
    >
      {data.map((item, index) => (
        <div
          className="detailexIndex-item-v2"
          role="region"
          aria-labelledby={`indicator-title-${index}`}
          key={index}
        >
          <button type="button" className="indicator-disclosure" aria-expanded={expandedIndex === index} aria-controls={`indicator-panel-${index}`} onClick={() => handleItemClick(index)}>
            <span id={`indicator-title-${index}`}>{item.title}</span>
          </button>
          <div id={`indicator-panel-${index}`}>
          <ItemIndicator
            item={item}
            index={index}
            expandedIndex={expandedIndex}
            handleItemClick={handleItemClick}
            atlist={item.production_activities}
            valueObject={item}
          />
          </div>

          {/* Renderiza a div condicional somente se expandedIndex for null */}
          {expandedIndex === null && (
            <div className="description-preview">
              <div className="description-preview-space"></div>
              <div className="decription-preview-content-v2">
                <div className="decription-preview-content-v2-p">
                  {item.description.main}
                </div>
                <Suspense fallback={null}>
                  <SimpleGraph
                    atlist={item.production_activities}
                    valueObject={item}
                  ></SimpleGraph>
                </Suspense>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  ) : (
    <div
      className={`container-detailedIndex-desktop ${
        expandedIndex !== null ? "has-expanded" : ""
      }`}
    >
      {data.map((item, index) => (
        <div
          className="detailexIndex-item-v2-desktop"
          role="region"
          aria-labelledby={`indicator-title-desktop-${index}`}
          key={index}
        >
          <button type="button" className="indicator-disclosure" aria-expanded={expandedIndex === index} aria-controls={`indicator-panel-desktop-${index}`} onClick={() => handleItemClick(index)}>
            <span id={`indicator-title-desktop-${index}`}>{item.title}</span>
          </button>
          <div id={`indicator-panel-desktop-${index}`}>
          <ItemIndicator
            item={item}
            index={index}
            expandedIndex={expandedIndex}
            handleItemClick={handleItemClick}
            atlist={item.production_activities}
            valueObject={item}
          />
          </div>

          {/* Renderiza a div condicional somente se expandedIndex for null */}
          {expandedIndex === null && (
            <div className="description-preview">
              <div className="description-preview-space"></div>
              <div className="decription-preview-content-v2">
                <div className="decription-preview-content-v2-p">
                  {item.description.main_desktop}
                </div>
                <Suspense fallback={null}>
                  <SimpleGraph
                    atlist={item.production_activities}
                    valueObject={item}
                  ></SimpleGraph>
                </Suspense>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};


  export default IndicatorInfo
  
